import { BaseComponentService } from 'src/app/services/_app/base-component.service';
import { ScholasticYear } from 'src/app/models/scholastic-year.model';
import { RingForm } from 'src/app/models/ring-form/ring-form.model';
import { ApiError } from 'src/app/models/api/api-error.model';
import { UserService } from 'src/app/services/user.service';
import { API } from 'src/app/constants/api';
import {
  Input,
  inject,
  Component,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  FiltersDialogComponent,
  FiltersDialogConfigInterface,
} from 'src/app/components/ring-forms/filters-dialog/filters-dialog.component';

@Component({
  selector: 'app-user-modules-data',
  templateUrl: './user-modules-data.component.html',
  styleUrls: ['./user-modules-data.component.scss'],
})
export class UserModulesDataComponent implements OnChanges {
  private _baseComponentService = inject(BaseComponentService);
  private _userService: UserService = inject(UserService);
  public loading: boolean = true;
  public error?: ApiError;

  @Input() startLoading: boolean = false;
  @Input() userId?: string;

  public forms: RingForm[] = [];
  private readonly _defaultFiltersDialogConfigs = {
    scholasticYear: ScholasticYear.getCurrent(),
    hideOwners: true,
  };
  private _filtersDialogConfigs: FiltersDialogConfigInterface = {
    scholasticYear: ScholasticYear.getCurrent(),
    hideOwners: true,
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['startLoading'].currentValue &&
      !changes['startLoading'].previousValue
    ) {
      this.getData();
    }
  }

  async getData() {
    this.loading = true;
    this.error = undefined;
    this._userService
      .getFormListing(this.userId, this._filtersDialogConfigs)
      .subscribe({
        next: (response) => {
          this.forms = response?.data?.map((form: any) => {
            return new RingForm(form);
          });
        },
        error: (error: unknown) => {
          this.error = new ApiError(error);
          console.error('User Forms Error: ', error);
        },
      })
      .add(() => (this.loading = false));
  }

  showFilterDialog() {
    this._baseComponentService.dialog
      .open(FiltersDialogComponent, {
        autoFocus: false,
        restoreFocus: false,
        data: this._filtersDialogConfigs,
      })
      .afterClosed()
      .subscribe((config: boolean | FiltersDialogConfigInterface) => {
        if (config == true) {
          this._filtersDialogConfigs = this._defaultFiltersDialogConfigs;
          this.getData();
        } else if (config != undefined && typeof config != 'boolean') {
          this._filtersDialogConfigs = config;
          this._filtersDialogConfigs.hideOwners = true;
          this.getData();
        }
      });
  }

  showPdfPreviewPDF(id?: string): void {
    this._baseComponentService.showPdfFromURL(API.getFormPDF(id || 'ID-ERROR'));
  }

  downloadFormPDF(id?: string): void {
    this._baseComponentService.downloadFile({
      url: API.getFormPDF(id || 'ID-ERROR'),
      defaultFileName: `${new Date().toISOString()} - Modulo`,
      withCredentials: true,
    });
  }
}
